import { createAction } from 'redux-act';

export const setCustomHeaders = createAction('Set custom headers');
export const headersReset = createAction('Reset custom headers');
